import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import PageMeta from '../../modules/PageMeta';
import SidebarColumn from '../../modules/SidebarColumn';
import PageSidebar from '../../modules/PageSidebar';
import ContentColumn from '../../modules/ContentColumn';
import PageSection from '../../modules/PageSection';
import LoadMoreButton from '../../modules/LoadMoreButton';
import Page from '../../pages/Page';

import styles from './styles.scss';

import * as auditLogActions from '../../../actions/audit_logs';

class AdminAuditLog extends React.Component {

    componentDidMount() {

        this.props.resetAuditLogs();
        this.props.loadMoreLogs(this.props.match.params.id);
    }

    render() {

        return (
            <Page>
                <PageMeta title="Audit Log" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>
                    <PageSection>

                        <Link to="/admin/users" className={styles['back-button']}>
                            &larr; Search Users
                        </Link>

                        {this.props.logs.length > 0 &&
                            <div>
                                <table className={styles['audit-log-table']}>
                                    <thead>
                                    <tr>
                                        <th>Event</th>
                                        <th>Service</th>
                                        <th>Date</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.props.logs.map((log, i) => {

                                        return (
                                            <tr key={i}>
                                                <td>{ log.description }</td>
                                                <td>{ log.service ? log.service.name : '\u2014' }</td>
                                                <td>{ moment.utc(log.created_at).local().format('MMMM Do YYYY HH:mm') }</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>

                                {this.props.isMoreToLoad && !this.props.isLoading &&
                                    <LoadMoreButton
                                        onClick={this.props.loadMoreLogs.bind(this, this.props.match.params.id)}
                                    >
                                        Load More
                                    </LoadMoreButton>
                                }
                            </div>
                        }

                        {this.props.isInitialised && this.props.logs.length === 0 &&
                            <p className={styles['no-logs-message']}>
                                There are no audit logs for this user yet.
                            </p>
                        }

                    </PageSection>
                </ContentColumn>
            </Page>
        )
    }
}

function mapStateToProps(state) {
    return {
        isLoading: state.auditLogs.isLoadingLogs,
        isInitialised: state.auditLogs.isLogsInitialised,
        isMoreToLoad: state.auditLogs.isMoreLogsToLoad,
        logs: state.auditLogs.logs
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadMoreLogs(userId) {
            dispatch(auditLogActions.loadMoreAuditLogs(userId));
        },
        resetAuditLogs() {
            dispatch(auditLogActions.resetLogs());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminAuditLog);